(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-mobile"] && !window.DesignMode) return;
  try {
    
if (!window.mobileSwiperInit) {
  window.mobileSwiperInit = true;
  document.addEventListener('DOMContentLoaded', function () {
const mobileSwiper = new Swiper('.featured-collection-mobile-swiper', {
  spaceBetween: 10,
  loop: false,
  navigation: {
    nextEl: '.swiper-button-next-mobile',
    prevEl: '.swiper-button-prev-mobile'
  },
  breakpoints: {
    0: {
      slidesPerView: 1
    },
    480: {
      slidesPerView: 2
    }
  }
});

  });
}

  } catch(e) { console.error(e); }
})();
})();
